export default {
    data() {
        return {
            downloadStates: {}
        };
    },
    methods: {
        isDownloadLoading(key) {
            return Boolean(key && this.downloadStates[key]);
        },
        getDownloadLabel(key, defaultLabel, loadingLabel = 'Preparando descarga...') {
            return this.isDownloadLoading(key) ? loadingLabel : defaultLabel;
        },
        async runDownload(key, action, options = {}) {
            if (!key || typeof action !== 'function') {
                return;
            }

            if (this.isDownloadLoading(key)) {
                return;
            }

            this.$set(this.downloadStates, key, true);

            if (options.notify !== false && this.$toasted && typeof this.$toasted.show === 'function') {
                this.$toasted.show(
                    options.message || 'La descarga se esta preparando. Esto puede tardar unos segundos.',
                    {
                        duration: options.duration || 3000,
                    }
                );
            }

            try {
                return await action();
            } finally {
                this.$set(this.downloadStates, key, false);
            }
        }
    }
};
